import React from 'react';
import { Button } from '../components/Button';
import { DarkCard, LightCard, CheckListItem } from '../components/Cards';
import { HeroDecorations, ImageDecorations, AboutDecorations } from '../components/Decorations';
import { EyeIcon, FingerprintIcon, AnchorIcon, TrendingUpIcon } from '../components/Icons';
import { CheckCircle2, Heart, Compass, Sparkles, Palette, Briefcase, Wrench, GitBranch } from 'lucide-react';
export function Despre() {
  return <main className="flex-grow bg-rise-white" data-id="element-633" data-mp="31dgg7kirvgi">
      {/* SECTION 1 - HERO (Light) - text left, photo top right */}
      <section className="relative py-12 md:py-20 bg-rise-white overflow-hidden" data-id="element-634" data-mp="3lge7z2y44phi">
        <HeroDecorations data-id="element-635" data-mp="3qeg0eehfi15n" />
        <div className="max-w-rise-content mx-auto px-6 relative z-10" data-id="element-636" data-mp="3qfr3sd6yp6w8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-637" data-mp="3bhowpt0q23a8">
            {/* Text column */}
            <div className="flex flex-col items-center lg:items-start text-center lg:text-left order-2 lg:order-1" data-id="element-638" data-mp="3ggruqtiab98p">
              <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-639" data-mp="2vqmvzwhwdkg0">
                Despre mine
              </span>
              <h1 className="font-playfair text-[36px] md:text-[56px] text-rise-black leading-tight mb-4" data-id="element-640" data-mp="34runnvpwrn14">
                Teodora Trifu
              </h1>
              <h2 className="font-playfair italic text-rise-gold text-[24px] md:text-[32px] leading-tight mb-6 max-w-xl" data-id="element-641" data-mp="2d0otdvwvcjjr">
                De la „nu sunt suficient(ă)" la „știu cine sunt"
              </h2>
              <p className="font-dm-sans text-[16px] md:text-[18px] tracking-wide text-rise-gray mb-6 max-w-xl" data-id="element-642" data-mp="2lts1rpsnq67j">
                Consilier pentru dezvoltare personală · 9 ani experiență cu
                tineri · Creatorul R.I.S.E. – Realitate • Identitate •
                Stabilitate • Evoluție
              </p>
              <p className="font-dm-sans text-[19px] text-rise-gray mb-10 leading-relaxed max-w-xl" data-id="element-643" data-mp="1paugjecjuuzi">
                Nu sunt aici să-ți spun „gândește pozitiv". Sunt aici să-ți ofer
                structură când mintea ta e în haos. Și pași reali când simți că
                viața ta e pe pauză.
              </p>
              <div className="flex flex-col gap-4 w-full max-w-sm" data-id="element-644" data-mp="21b2pepvbpxb">
                <Button variant="primary" href="https://comunitatearise.ro/ofertarise" target="_top" className="w-full" data-id="element-645" data-mp="705perqyhymp">
                  Intră în Programul R.I.S.E.
                </Button>
                <Button variant="secondary-dark" href="https://comunitatearise.ro/comunitaterise" target="_top" className="w-full" data-id="element-646" data-mp="3ff650m90fetj">
                  Intră în Comunitatea R.I.S.E.
                </Button>
                <Button variant="secondary-dark" href="https://comunitatearise.ro/coaching1la1" target="_top" className="w-full" data-id="element-647" data-mp="zob878yg9djw">
                  Aplică pentru 1:1 cu Teodora
                </Button>
              </div>
            </div>

            {/* Image column - top right */}
            <div className="order-1 lg:order-2 relative max-w-md mx-auto w-full" data-id="element-648" data-mp="2aefzdrtp0m6e">
              <ImageDecorations type={1} data-id="element-649" data-mp="25hfuhk8kxpgv" />
              <img src="https://cdn.magicpatterns.com/uploads/5cTB7VyUXGVsL6aadBqWkg/Teodora_2.jpg" alt="Teodora Trifu" className="w-full h-auto aspect-[3/4] object-cover object-top rounded-xl shadow-xl relative z-10" data-id="element-650" data-mp="20icvohj70fhc" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 — Tineri capabili (Dark) */}
      <section className="py-12 md:py-20 bg-rise-anthracite" data-id="element-651" data-mp="3lvpi2c4zza6n">
        <div className="max-w-rise-content mx-auto px-6" data-id="element-652" data-mp="3lv69vn55g05t">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-653" data-mp="3gwlatr1mvmiy">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-654" data-mp="2ejgoytmjxrd9">
              Ce văd mereu la tineri
            </span>
            <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-white mb-6" data-id="element-655" data-mp="24lshd33ukpdo">
              Tineri capabili. Blocați de frică și presiune.
            </h2>
            <p className="font-dm-sans text-[19px] text-rise-white/80 leading-relaxed" data-id="element-656" data-mp="29m6rcqp0e9ec">
              Am lucrat ani întregi cu tineri și am văzut același lucru în forme
              diferite: oameni inteligenți, sensibili, cu potențial, care nu se
              mișcă pentru că se simt prinși între:
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-657" data-mp="1qtchuca5n9hi">
            <DarkCard title="Perfecționismul Paralizant" watermark="P" icon={<svg className="w-12 h-12" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-659" data-mp="1gvex3yri7utn">
                  <circle cx="24" cy="24" r="20" strokeDasharray="4 3" data-id="element-660" data-mp="178lsn6nz1yqo" />
                  <circle cx="24" cy="24" r="12" data-id="element-661" data-mp="175pwnnvopk4v" />
                  <circle cx="24" cy="24" r="4" data-id="element-662" data-mp="127y20m3nnjwz" />
                  <line x1="24" y1="4" x2="24" y2="8" data-id="element-663" data-mp="12bc4ducbjt4f" />
                  <line x1="24" y1="40" x2="24" y2="44" data-id="element-664" data-mp="1g7fwni3mtre9" />
                  <line x1="4" y1="24" x2="8" y2="24" data-id="element-665" data-mp="1c7f6j0767rrd" />
                  <line x1="40" y1="24" x2="44" y2="24" data-id="element-666" data-mp="1c6x2hhe9o98w" />
                </svg>} data-id="element-658" data-mp="1qrhz94mcvtgl">
              <p className="italic mb-4 text-rise-white/60" data-id="element-667" data-mp="1pxsj5fv0bun1">
                „Trebuie să aleg perfect."
              </p>
              <p data-id="element-668" data-mp="1zwrfbyyl5xt5">
                Frica de a face o alegere greșită te ține pe loc, analizând la
                nesfârșit opțiunile fără a acționa.
              </p>
            </DarkCard>
            <DarkCard title="Frica de Eșec" watermark="E" icon={<svg className="w-12 h-12" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-670" data-mp="26zxxqnpqwe1i">
                  <path d="M24 4 L44 24 L24 44 L4 24 Z" data-id="element-671" data-mp="2loucf3mb4pb3" />
                  <path d="M24 14 L34 24 L24 34 L14 24 Z" strokeDasharray="3 3" data-id="element-672" data-mp="2loaz607lqp3e" />
                  <line x1="24" y1="18" x2="24" y2="30" data-id="element-673" data-mp="2upir80jiytp1" />
                  <circle cx="24" cy="33" r="1.5" fill="currentColor" stroke="none" data-id="element-674" data-mp="2uq23p1qeopvo" />
                </svg>} data-id="element-669" data-mp="1uvtx5mdkt3rn">
              <p className="italic mb-4 text-rise-white/60" data-id="element-675" data-mp="15a2kert2pk2b">
                „Dacă greșesc, am stricat tot."
              </p>
              <p data-id="element-676" data-mp="xruzq5uia6dg">
                Presiunea de a reuși din prima încercare transformă orice mică
                greșeală într-o catastrofă personală.
              </p>
            </DarkCard>
            <DarkCard title="Sindromul Impostorului" watermark="I" icon={<svg className="w-12 h-12" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-678" data-mp="j3qdwt05peqg">
                  <circle cx="24" cy="16" r="8" data-id="element-679" data-mp="16q6py6rgn25d" />
                  <path d="M10 44 C10 34 18 28 24 28 C30 28 38 34 38 44" data-id="element-680" data-mp="11swxsjcoscdu" />
                  <circle cx="24" cy="16" r="12" strokeDasharray="4 4" data-id="element-681" data-mp="11v10wz2rh7d2" />
                  <line x1="16" y1="14" x2="20" y2="14" data-id="element-682" data-mp="3rjjs3170me4c" />
                  <line x1="28" y1="14" x2="32" y2="14" data-id="element-683" data-mp="3midy701mckt8" />
                </svg>} data-id="element-677" data-mp="o2bgv06smcil">
              <p className="italic mb-4 text-rise-white/60" data-id="element-684" data-mp="g1dr4rpeaxrv">
                „Dacă nu sunt pregătit(ă), mai bine nu mă expun."
              </p>
              <p data-id="element-685" data-mp="kyne80pbaxcj">
                Senzația constantă că nu ești suficient de bun sau pregătit
                pentru a-ți asuma oportunități.
              </p>
            </DarkCard>
            <DarkCard title="Anxietatea Timpului" watermark="T" icon={<svg className="w-12 h-12" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-687" data-mp="yu7xwycv7jl0">
                  <circle cx="24" cy="26" r="18" data-id="element-688" data-mp="tzbwx8pnhlvr" />
                  <polyline points="24 14 24 26 32 30" data-id="element-689" data-mp="1hpy28s89ss22" />
                  <line x1="20" y1="4" x2="28" y2="4" data-id="element-690" data-mp="1hp68lmy8h4ef" />
                  <line x1="24" y1="4" x2="24" y2="8" data-id="element-691" data-mp="1miis5io22l0b" />
                  <path d="M8 10 L12 14" data-id="element-692" data-mp="377ux2pty3qag" />
                  <path d="M40 10 L36 14" data-id="element-693" data-mp="376tjoepgirpk" />
                </svg>} data-id="element-686" data-mp="b32hoi30ipa6">
              <p className="italic mb-4 text-rise-white/60" data-id="element-694" data-mp="3289yigiotjy9">
                „Simt că pierd timpul și rămân în urmă."
              </p>
              <p data-id="element-695" data-mp="3h00ljpkznpkw">
                Comparația constantă cu ceilalți și presiunea de a atinge
                anumite borne la o anumită vârstă.
              </p>
            </DarkCard>
          </div>
          <div className="text-center max-w-2xl mx-auto" data-id="element-696" data-mp="2obczvswbuy6t">
            <p className="font-dm-sans text-[19px] text-rise-gold font-medium" data-id="element-697" data-mp="2jb8qsnxr15qm">
              Problema nu e lipsa de ambiție. Problema e lipsa unei structuri
              care să transforme confuzia în direcție.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3 — De ce fac asta (Light, photo left + text right) */}
      <section className="relative py-12 md:py-20 bg-rise-white overflow-hidden" data-id="element-698" data-mp="dj21vglgm36y">
        <AboutDecorations data-id="element-699" data-mp="8hup134gmdtf" />
        <div className="max-w-rise-content mx-auto px-6 relative z-10" data-id="element-700" data-mp="z12lzim9q3qg">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-701" data-mp="z35c02nf7wv6">
            <div className="order-2 lg:order-1 relative" data-id="element-702" data-mp="u2hnpoqktu4n">
              <ImageDecorations type={2} data-id="element-703" data-mp="papu15c4j8aa" />
              <img src="https://cdn.magicpatterns.com/uploads/5cTB7VyUXGVsL6aadBqWkg/Teodora_2.jpg" alt="Teodora Trifu" className="w-full h-auto aspect-[3/4] object-cover object-top rounded-xl shadow-xl relative z-10" data-id="element-704" data-mp="p9ojr32xmptm" />
            </div>
            <div className="order-1 lg:order-2" data-id="element-705" data-mp="b9wz4jhwub6n">
              <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-706" data-mp="6c543glyy8y8">
                De ce fac asta
              </span>
              <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-black mb-6" data-id="element-707" data-mp="20qo6lj6igcg9">
                De la lucru cu tinerii la o misiune clară
              </h2>
              <div className="space-y-6 font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-708" data-mp="23b441ofdos79">
                <p data-id="element-709" data-mp="289nrjt9mec1q">
                  Lucrez de 9 ani cu copii și tineri, iar de 5 ani sunt
                  implicată direct în dezvoltarea emoțională a tinerilor din
                  medii defavorizate prin ONG-ul pe care l-am construit.
                </p>
                <p data-id="element-710" data-mp="2hyyx55xasykv">
                  Am înțeles repede ceva important: tinerii nu au nevoie doar de
                  inspirație. Au nevoie de un cadru sigur, de instrumente simple
                  și de o comunitate care îi susține fără să îi judece.
                </p>
                <p className="font-medium text-rise-black border-l-2 border-rise-gold pl-6 py-2" data-id="element-711" data-mp="1u94oz1nxby6y">
                  Așa a apărut ideea R.I.S.E.: un mod clar de a construi
                  identitate, stabilitate și progres real, nu doar „încă un
                  episod de overthinking".
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4 — Cum lucrez, pe scurt (Dark) */}
      <section className="py-12 md:py-20 bg-rise-anthracite" data-id="element-712" data-mp="1anzjvol4il2z">
        <div className="max-w-rise-content mx-auto px-6" data-id="element-713" data-mp="15ma7a4i95zcs">
          <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-714" data-mp="1jmkyj8nh5fyh">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-715" data-mp="1jkqnqn5x3484">
              Expertiză
            </span>
            <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-white mb-6" data-id="element-716" data-mp="rtare1ek634p">
              Cum lucrez (pe scurt)
            </h2>
            <p className="font-dm-sans text-[19px] text-rise-white/70 leading-relaxed" data-id="element-717" data-mp="10p0lcyu2o5tp">
              Combin formare academică, experiență practică și metode creative,
              pentru ca procesul să fie clar, aplicat și uman.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-718" data-mp="462otr8il86d">
            <DarkCard title="Sunt formată ca" icon={<Briefcase size={28} data-id="element-720" data-mp="3q7tjh8rihbgu" />} data-id="element-719" data-mp="45ubxzce62v6">
              <ul className="space-y-3" data-id="element-721" data-mp="3q6ryabgs78le">
                <CheckListItem data-id="element-722" data-mp="3uy9xov35p149">
                  <span className="text-rise-white" data-id="element-723" data-mp="3uyi9skrgg2ee">
                    Lucrător prin arte combinate
                  </span>
                </CheckListItem>
                <CheckListItem data-id="element-724" data-mp="3g7j4pjptvvzk">
                  <span className="text-rise-white" data-id="element-725" data-mp="3l7xg9bqn1o2c">
                    Consilier pentru dezvoltare personală
                  </span>
                </CheckListItem>
              </ul>
            </DarkCard>
            <DarkCard title="În munca mea combin" icon={<Wrench size={28} data-id="element-727" data-mp="hqyp6hos4zed" />} data-id="element-726" data-mp="hs05p1okee3h">
              <ul className="space-y-3" data-id="element-728" data-mp="2upsnnw9x05n">
                <CheckListItem data-id="element-729" data-mp="2to9ew53t7cu">
                  <span className="text-rise-white" data-id="element-730" data-mp="2wtve2ifrt4c">
                    Procese ghidate de autocunoaștere
                  </span>
                </CheckListItem>
                <CheckListItem data-id="element-731" data-mp="2njx5ennmvdii">
                  <span className="text-rise-white" data-id="element-732" data-mp="2nn1f20jvb1gk">
                    Reglare emoțională (practică, aplicabilă)
                  </span>
                </CheckListItem>
                <CheckListItem data-id="element-733" data-mp="38sh7vhkvaub6">
                  <span className="text-rise-white" data-id="element-734" data-mp="38sr1rg919lm5">
                    Metode experiențiale și creative
                  </span>
                </CheckListItem>
                <CheckListItem data-id="element-735" data-mp="2z1mkg9vvxoo5">
                  <span className="text-rise-white" data-id="element-736" data-mp="2yyrygdx83vsm">
                    Structură + pași concreți (nu doar discuții)
                  </span>
                </CheckListItem>
              </ul>
            </DarkCard>
          </div>
        </div>
      </section>

      {/* SECTION 5 — Metoda R.I.S.E. (Light) */}
      <section className="py-12 md:py-20 bg-rise-white" data-id="element-737" data-mp="3hrm5mlolujma">
        <div className="max-w-rise-content mx-auto px-6" data-id="element-738" data-mp="3hq19irmn6smb">
          <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-739" data-mp="3ct132flvrnuo">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-740" data-mp="3cum1whf89syc">
              Metoda
            </span>
            <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-black mb-6" data-id="element-741" data-mp="21fp70qwd49j2">
              R.I.S.E. – structura pe care o folosim în comunitate
            </h2>
            <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-742" data-mp="luocibqfmr45">
              R.I.S.E. înseamnă 4 etape prin care treci când vrei să ieși din
              blocaj și să-ți construiești o viață cu sens:
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-743" data-mp="10ju9dt1ss58v">
            <div className="bg-white border border-gray-200 shadow-sm rounded-xl p-8 flex flex-col relative" data-id="element-744" data-mp="10lnjxjfj79m5">
              <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold rounded-t-xl" data-id="element-745" data-mp="19k8vguml5odf"></div>
              <div className="text-rise-gold mb-4" data-id="element-746" data-mp="1ej27sjq4z9c0">
                <EyeIcon data-id="element-747" data-mp="1eik4x48yxwv4" />
              </div>
              <div className="font-playfair text-rise-gold text-[28px] mb-1" data-id="element-748" data-mp="3bbcadw3idp3s">
                R
              </div>
              <h3 className="font-playfair text-rise-black text-[22px] mb-3" data-id="element-749" data-mp="3g9x9ttaxs4r6">
                Realitate
              </h3>
              <p className="font-dm-sans text-rise-gray text-[16px] leading-relaxed" data-id="element-750" data-mp="38asnpjc55dxw">
                Înțelegi ce simți, fără rușine și fără fugă.
              </p>
            </div>
            <div className="bg-white border border-gray-200 shadow-sm rounded-xl p-8 flex flex-col relative" data-id="element-751" data-mp="3i870n8yuvklg">
              <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold rounded-t-xl" data-id="element-752" data-mp="3d7spvj5vdwjq"></div>
              <div className="text-rise-gold mb-4" data-id="element-753" data-mp="3r7jzz8t9mssg">
                <FingerprintIcon data-id="element-754" data-mp="3r68yxgr7fz51" />
              </div>
              <div className="font-playfair text-rise-gold text-[28px] mb-1" data-id="element-755" data-mp="3n68jptwa7jwx">
                I
              </div>
              <h3 className="font-playfair text-rise-black text-[22px] mb-3" data-id="element-756" data-mp="4sivkx881vmi">
                Identitate
              </h3>
              <p className="font-dm-sans text-rise-gray text-[16px] leading-relaxed" data-id="element-757" data-mp="3w1o99yq07cwp">
                Valori, talente, direcție potrivită pentru tine.
              </p>
            </div>
            <div className="bg-white border border-gray-200 shadow-sm rounded-xl p-8 flex flex-col relative" data-id="element-758" data-mp="9tybybzgfdyk">
              <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold rounded-t-xl" data-id="element-759" data-mp="tc2o52fz9gzs"></div>
              <div className="text-rise-gold mb-4" data-id="element-760" data-mp="xdeeja6oe691">
                <AnchorIcon data-id="element-761" data-mp="jeo8v65siy92" />
              </div>
              <div className="font-playfair text-rise-gold text-[28px] mb-1" data-id="element-762" data-mp="ji3oqb7agbbj">
                S
              </div>
              <h3 className="font-playfair text-rise-black text-[22px] mb-3" data-id="element-763" data-mp="9pxwd0d4jrvt">
                Stabilitate
              </h3>
              <p className="font-dm-sans text-rise-gray text-[16px] leading-relaxed" data-id="element-764" data-mp="egwg69xbn83t">
                Plan clar + pași mici, constanți.
              </p>
            </div>
            <div className="bg-white border border-gray-200 shadow-sm rounded-xl p-8 flex flex-col relative" data-id="element-765" data-mp="5ocgd65amxhe">
              <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold rounded-t-xl" data-id="element-766" data-mp="3mwpuqj83e9i8"></div>
              <div className="text-rise-gold mb-4" data-id="element-767" data-mp="3rv9kyvtpy7ge">
                <TrendingUpIcon data-id="element-768" data-mp="3rurgjbwwkmxe" />
              </div>
              <div className="font-playfair text-rise-gold text-[28px] mb-1" data-id="element-769" data-mp="b8ofm4lpm1vv">
                E
              </div>
              <h3 className="font-playfair text-rise-black text-[22px] mb-3" data-id="element-770" data-mp="77mfzmnvrntd">
                Evoluție
              </h3>
              <p className="font-dm-sans text-rise-gray text-[16px] leading-relaxed" data-id="element-771" data-mp="25x3s3ox943p">
                Mindset matur, progres pe termen lung.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6 — Înainte de metode, sunt om (Dark) */}
      <section className="py-12 md:py-20 bg-rise-anthracite relative overflow-hidden" data-id="element-772" data-mp="3jmx1yuxn1wfl">
        <div className="absolute top-0 right-0 w-72 h-72 bg-rise-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-773" data-mp="3fllbkn6xx76c"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 bg-rise-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-774" data-mp="3aol180325i9f"></div>
        <div className="max-w-rise-content mx-auto px-6 relative z-10" data-id="element-775" data-mp="35qb7ltwzeppx">
          <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-776" data-mp="30qf19o0tam77">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-777" data-mp="2qlowlae0x3za">
              Dincolo de titluri
            </span>
            <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-white mb-8" data-id="element-778" data-mp="30kegt9te70ip">
              Înainte de metode, sunt om
            </h2>
            <div className="space-y-6 font-dm-sans text-[19px] text-rise-white/80 leading-relaxed" data-id="element-779" data-mp="35g3jvn4mezjr">
              <p data-id="element-780" data-mp="27suq74uguk6o">
                Îmi place un stil de viață lent și conștient. Îmi place să
                învăț, să creez și să construiesc spații în care oamenii se simt
                în siguranță să fie ei.
              </p>
              <p className="text-rise-gold font-playfair italic text-[22px] md:text-[26px]" data-id="element-781" data-mp="2mk3qq8zwppyl">
                Cred în profunzime, dar și în simplitate. În emoții, dar și în
                acțiune. În comunitate, dar și în responsabilitate personală.
              </p>
            </div>
          </div>
          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto mt-12" data-id="element-782" data-mp="3mc586qlx31f3">
            <div className="bg-rise-black border border-rise-gold/40 rounded-xl p-6 text-center" data-id="element-783" data-mp="3raq78mpfnf1y">
              <Heart className="text-rise-gold mx-auto mb-3" size={28} data-id="element-784" data-mp="4fc1773t8ij" />
              <p className="font-dm-sans text-rise-white/80 text-[15px]" data-id="element-785" data-mp="2b0c32yr57p">
                Stil de viață lent, conștient
              </p>
            </div>
            <div className="bg-rise-black border border-rise-gold/40 rounded-xl p-6 text-center" data-id="element-786" data-mp="33lxaio0zl36a">
              <Palette className="text-rise-gold mx-auto mb-3" size={28} data-id="element-787" data-mp="38jfmyoe7q0j1" />
              <p className="font-dm-sans text-rise-white/80 text-[15px]" data-id="element-788" data-mp="3cm2h4vycvxje">
                Învăț, creez, construiesc spații sigure
              </p>
            </div>
            <div className="bg-rise-black border border-rise-gold/40 rounded-xl p-6 text-center" data-id="element-789" data-mp="3hdu0omj3h301">
              <Compass className="text-rise-gold mx-auto mb-3" size={28} data-id="element-790" data-mp="2kue9gmqivz6w" />
              <p className="font-dm-sans text-rise-white/80 text-[15px]" data-id="element-791" data-mp="2oux0iekld181">
                Profunzime + simplitate, emoții + acțiune
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 — Ce obțin oamenii când lucrează cu mine (Light) */}
      <section className="py-12 md:py-20 bg-rise-white" data-id="element-792" data-mp="28azd3qmoz263">
        <div className="max-w-rise-content mx-auto px-6" data-id="element-793" data-mp="28dv8p8b2herd">
          <div className="text-center mb-12" data-id="element-794" data-mp="23c60s1j55h7i">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-795" data-mp="1yduolk5dium4">
              Rezultate reale
            </span>
            <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-black mb-4" data-id="element-796" data-mp="1onjlfztikpga">
              Ce obțin oamenii când lucrează cu mine
            </h2>
            <div className="w-24 h-1 bg-rise-gold mx-auto" data-id="element-797" data-mp="1kkd7e605ttz9"></div>
          </div>
          <div className="max-w-3xl mx-auto bg-white border border-gray-200 shadow-sm rounded-xl p-8 md:p-12" data-id="element-798" data-mp="1fmtogssiot0z">
            <p className="font-dm-sans text-[19px] text-rise-gray mb-8" data-id="element-799" data-mp="1aqd4mascp0tp">
              Oamenii cu care lucrez ajung să:
            </p>
            <div className="space-y-6" data-id="element-800" data-mp="15zhcldwynqy8">
              <div className="flex items-start gap-4" data-id="element-801" data-mp="161c275j6g78n">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={22} data-id="element-802" data-mp="r2qdz6v42j9o" />
                <p className="font-dm-sans text-[18px] leading-relaxed" data-id="element-803" data-mp="w2cqfe347vhf">
                  <span className="font-semibold text-rise-black" data-id="element-804" data-mp="1jqmaobkokb6g">
                    Își înțeleagă emoțiile
                  </span>
                  <span className="text-rise-gray" data-id="element-805" data-mp="1oppfpw0nuhef">
                    {' '}
                    și să nu se mai sperie de ele.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-806" data-mp="1ez4gq7h2rauz">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={22} data-id="element-807" data-mp="22q9w6lj3s14r" />
                <p className="font-dm-sans text-[18px] leading-relaxed" data-id="element-808" data-mp="27hi7jn3ztwkk">
                  <span className="font-semibold text-rise-black" data-id="element-809" data-mp="3s6lwgtigrgfa">
                    Ia decizii mai clare
                  </span>
                  <span className="text-rise-gray" data-id="element-810" data-mp="3n79987nok7c6">
                    , fără autocritică paralizantă.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-811" data-mp="ry4pfnvnmmt">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={22} data-id="element-812" data-mp="ukjo0d3l4f2" />
                <p className="font-dm-sans text-[18px] leading-relaxed" data-id="element-813" data-mp="349q0l554wqqa">
                  <span className="font-semibold text-rise-black" data-id="element-814" data-mp="34bjactb1nr2i">
                    Pună limite
                  </span>
                  <span className="text-rise-gray" data-id="element-815" data-mp="3e6uphcqd70as"> fără vinovăție.</span>
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-816" data-mp="xhz0vzqkt5e5">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={22} data-id="element-817" data-mp="xkl6httwpatq" />
                <p className="font-dm-sans text-[18px] leading-relaxed" data-id="element-818" data-mp="1ortn1vuhfeps">
                  <span className="font-semibold text-rise-black" data-id="element-819" data-mp="1ssx4gms6hit4">
                    Facă pași concreți
                  </span>
                  <span className="text-rise-gray" data-id="element-820" data-mp="1xrqiqhfahduc">
                    {' '}
                    în direcția lor (nu doar planuri).
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-821" data-mp="27qzad3momgdj">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={22} data-id="element-822" data-mp="27o3bnd30fno1" />
                <p className="font-dm-sans text-[18px] leading-relaxed" data-id="element-823" data-mp="2ghzkxrb2t5m1">
                  <span className="font-semibold text-rise-black" data-id="element-824" data-mp="2gku7bodnh0i3">
                    Simtă stabilitate
                  </span>
                  <span className="text-rise-gray" data-id="element-825" data-mp="2qh7630o1y4jp">
                    {' '}
                    și încredere în viața de zi cu zi.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 — Final CTA (Dark intens) */}
      <section className="py-14 md:py-24 bg-rise-black text-center relative overflow-hidden" data-id="element-826" data-mp="et2bli6r2j94">
        <div className="absolute inset-0 opacity-10 pointer-events-none flex items-center justify-center" data-id="element-827" data-mp="9tfpskcuvuop">
          <div className="w-[800px] h-[800px] border-[1px] border-rise-gold rounded-full" data-id="element-828" data-mp="4w7hrclf9716"></div>
          <div className="absolute w-[600px] h-[600px] border-[1px] border-rise-gold rounded-full" data-id="element-829" data-mp="12j68l6pfnkr5"></div>
          <div className="absolute w-[400px] h-[400px] border-[1px] border-rise-gold rounded-full" data-id="element-830" data-mp="xkux6rjhp26t"></div>
        </div>
        <div className="max-w-rise-content mx-auto px-6 relative z-10" data-id="element-831" data-mp="srilfhzwspvh">
          <h2 className="font-playfair text-[36px] md:text-[48px] text-rise-white mb-6" data-id="element-832" data-mp="nus1ukowbc5b">
            Vrei să ieși din blocaj și să începi, pe bune?
          </h2>
          <p className="font-dm-sans text-[19px] text-rise-white/80 mb-12 max-w-2xl mx-auto" data-id="element-833" data-mp="1giny5oajz21k">
            Nu trebuie să faci asta singur(ă). Alege varianta care ți se
            potrivește acum.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-834" data-mp="3fpcv2mv060yl">
            <Button variant="primary" href="https://comunitatearise.ro/ofertarise" target="_top" className="text-[16px] py-5 px-10" data-id="element-835" data-mp="3frfgetl7n5wz">
              Intră în Programul R.I.S.E.
            </Button>
            <Button variant="primary" href="https://comunitatearise.ro/comunitaterise" target="_top" className="text-[16px] py-5 px-10" data-id="element-836" data-mp="2rygub08kjvf7">
              Intră în Comunitatea R.I.S.E.
            </Button>
            <Button variant="primary" href="https://comunitatearise.ro/coaching1la1" target="_top" className="text-[16px] py-5 px-10" data-id="element-837" data-mp="2n05l8rq3loy1">
              Aplică pentru 1:1 cu Teodora
            </Button>
          </div>
          <p className="font-dm-sans text-[14px] text-rise-white/50 italic" data-id="element-838" data-mp="25rd16g4192p7">
            Locuri limitate la 1:1 și în Programul R.I.S.E. (max 20 persoane).
          </p>
        </div>
      </section>
    </main>;
}